export default "__VITE_ASSET__dced6223__"